module.exports = __webpack_public_path__ + "static/media/dear-firebase-vertical-lockup.18b97ab3.svg";